import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

export default {
  render: (h: any) => h(App),
  router,
  store
}
